export const SET_MY_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
export const SET_MY_USER_LOADING = 'SET_MY_USER_LOADING';
export const UPDATE_ANCESTRY_FILES = 'UPDATE_ANCESTRY_FILES';
